import React from 'react'

export default function LearnMore() {
    return (
        <>
            <p className='text-buttonColor underline my-auto cursor-pointer'>Learn More</p>
        </>
    )
}
